import AbsComponent from '../../common/components/AbsComponent';
import Templ from './FriendTempl';
/**
 * Friend class
 * @category mainApp
 */
class PersonalSet extends AbsComponent{
  constructor(_store = {}, _el = '') {
    super(_store, _el);

    this.setting();
  }

  setting(){
    if(this.store.getData('config').isLogin){
      $('.personal').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 3800,
            settings: "unslick"
          },
          {
            breakpoint: 959,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var mySlideNumber = nextSlide;
        $('.personal-nav-item[data-slide]').removeClass('is-active');
        $('.personal-nav-item[data-slide]').eq(mySlideNumber).addClass('is-active');
      });
      $('.personal-nav-item[data-slide]').click(function(e) {
        e.preventDefault();
        $('.personal-nav-item[data-slide]').removeClass('is-active');
        $(this).addClass('is-active');
        var _slide = $(this).data('slide');
        $('.personal').slick('slickGoTo', _slide - 1);
      });

      $('#MyCommunity').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 3800,
            settings: "unslick"
          },
          {
            breakpoint: 959,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

      $(window).on('resize orientationchange', function() {
        $('.personal').slick('resize');
        $('#MyCommunity').slick('resize');
      });
    }else{
      $('.section-benefit').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 3800,
            settings: "unslick"
          },
          {
            breakpoint: 959,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
      $(window).on('resize orientationchange', function() {
        $('.section-benefit').slick('resize');
      });
    }
    $('#cardTypecols3').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 3800,
          settings: "unslick"
        },
        {
          breakpoint: 959,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    $('#cardTypeCommunuty').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 3800,
          settings: "unslick"
        },
        {
          breakpoint: 959,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    $(window).on('resize orientationchange', function() {
      $('#cardTypeCommunuty').slick('resize');
      $('#cardTypecols3').slick('resize');
    });
  }
}

export default PersonalSet;